import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { BaseDataService } from '../../libs/data-service/base-data-service';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { ContactUs } from './def/contactus';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';
import { BaseContentService } from './base-content-service';

@Injectable({
  providedIn: 'root'
})
export class ContactusService extends BaseContentService<ContactUs> {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http, configService, ContactusService.staticContact);
  }

  get data$(): Observable<ContactUs> {
    if (!this.loaded) {
      return this.getContactUsdData();
    }

    return of(this.data);
  }

  getContactUsdData(): Observable<ContactUs> {
    const url = `${this.serviceBaseUrl}contactus`;
    return this.get<ContactUs>(url).pipe(
      map(data => {
        this.data = this.contactUsMapper(data);
        this.loaded = true;
        return this.data;
      }),
      catchError(this.handleError)
    );
  }

  private contactUsMapper(data: ContactUs): ContactUs {
    if (!data) return;

    return data;
  }

  private static staticContact: ContactUs = {
    pageName: 'contactus',
    forms: [
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          }
        ]
      },
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '1',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          }
        ]
      }
    ],
    data: [
      {
        heading: '',
        title: '',
        description: '',
        text: '',
        image: null,
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    dropdown: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    buttons: [
      {
        keyText: 'Chat Now'
      },
      {
        keyText: 'Contact Us'
      },
      {
        keyText: 'Cancel'
      },
      {
        keyText: 'Submit'
      }
    ]
  };
}
